module.exports = {
  footerText: "Copyright LIFT © ",
};
